module.exports = __webpack_public_path__ + "static/media/bannerP.198b0485.png";